export const INITIAL_SWITHCER_INDEX = 0;
